import React, { Component } from "react";
import PropTypes from "prop-types";
import { OrganizationService } from "@services";
import {
	PaymentMethods,
	DirectDeposit,
	Notifications,
	UserInformation,
	Security,
	AgencyInfo,
	SettingsMenu,
} from "./components";

import "./MyAccount.scss";

class MyAccount extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeSection: "accountinformation",
			TransferCoordinatorPaymentToJurisdiction: false,
		};
	}

	componentDidMount() {
		// Observer to fix the menu in place when needed
		this.menuObserver = new IntersectionObserver(
			([entry]) => {
				if (!entry.isIntersecting) {
					document.getElementById("my-account-settings-menu").classList.add("fixed");
				} else {
					document.getElementById("my-account-settings-menu").classList.remove("fixed");
				}
			},
			{ root: null, rootMargin: "0px", threshold: 0 },
		);

		if (this.settingsMenuTitle) {
			this.menuObserver.observe(this.settingsMenuTitle);
		}

		// Observer to sync visible section with menu item
		this.sectionObserver = new IntersectionObserver(
			sections => {
				const pageOffset = window.pageYOffset;
				if (pageOffset === 0) {
					this.setState({ activeSection: "accountinformation" });
				} else {
					sections.forEach(section => {
						if (section.isIntersecting) {
							const { target } = section;
							this.setState({ activeSection: target.id });
						}
					});
				}
			},
			{ root: null, rootMargin: "-15% 0px -84% 0px", threshold: 0.01 },
		);

		const sections = [
			this.accountinformation,
			this.agencyinformation,
			this.security,
			this.paymentmethods,
			this.directdeposit,
			this.notifications,
		];

		sections.forEach(item => {
			if (item) this.sectionObserver.observe(item);
		});

		// Redirect to a specific section of the page
		const {
			router: {
				location: { hash },
			},
		} = this.props;
		if (hash) {
			const newSection = hash.replace("#", "");
			this.scrollToSection(newSection)();
		}

		OrganizationService.getJurisdictionPaymentRules()
			.then(({ data: { TransferCoordinatorPaymentToJurisdiction } }) => {
				this.setState({ TransferCoordinatorPaymentToJurisdiction });
			})
			.catch(() => {});
	}

	componentWillUnmount() {
		// Cancel all IntersectionObserver subscriptions
		this.menuObserver.disconnect();
		this.sectionObserver.disconnect();
	}

	/**
	 * Scrolls the user to the specific section when clicked
	 * @param {Number} id The unique id of the section the user will be scrolled to
	 */
	scrollToSection = id => () => {
		const { activeSection } = this.state;

		if (id === activeSection) return;

		// Default values in case id is not valid
		let newSection = "accountinformation";
		let top = 0;

		if (id) {
			// Add 110 to position the section header at the top of the page
			// eslint-disable-next-line no-unsafe-optional-chaining
			top = document.getElementById(id)?.offsetTop + 110;
			newSection = id;
		}

		// Internet Explorer Check: documentMode only exists in IE
		if (window.document.documentMode) {
			document.documentElement.scrollTop = top;
		} else {
			window.scrollTo({ top, behavior: "smooth" });
		}

		this.setState({ activeSection: newSection });
	};

	render() {
		const { lang } = global;
		const { activeSection, TransferCoordinatorPaymentToJurisdiction } = this.state;
		const { user } = this.props;

		return (
			<div
				className="container"
				id="my-account"
			>
				<div className="row">
					<div className="col-md-8">
						<div
							id="accountinformation"
							ref={ref => {
								this.accountinformation = ref;
							}}
						>
							<UserInformation user={user} />
						</div>

						<If condition={user.isCoordinator() && user.IsStaffAdmin}>
							<div
								id="agencyinformation"
								ref={ref => {
									this.agencyinformation = ref;
								}}
							>
								<AgencyInfo user={user} />
							</div>
						</If>

						<div
							id="security"
							ref={ref => {
								this.security = ref;
							}}
						>
							<Security user={user} />
						</div>

						<div
							id="notifications"
							ref={ref => {
								this.notifications = ref;
							}}
						>
							<Notifications />
						</div>

						<If
							condition={
								(user.isAgencyAdmin() && user.IsStaffAdmin) || user.isSuperAdmin()
							}
						>
							<div
								id="paymentmethods"
								ref={ref => {
									this.paymentmethods = ref;
								}}
							>
								<PaymentMethods user={user} />
							</div>
						</If>

						<If
							condition={
								!user.IsViewOnly &&
								((user.isLEA() &&
									(user.IsStaffAdmin ||
										!TransferCoordinatorPaymentToJurisdiction)) ||
									user.isCoordinator())
							}
						>
							<div
								id="directdeposit"
								ref={ref => {
									this.directdeposit = ref;
								}}
							>
								<DirectDeposit user={user} />
							</div>
						</If>
					</div>
					<div className="hidden-xs hidden-sm col-md-4">
						<h4
							ref={ref => {
								this.settingsMenuTitle = ref;
							}}
						>
							{lang.t("Settings Menu")}
						</h4>
						<SettingsMenu
							user={user}
							showDirectDeposit={
								!user.IsViewOnly &&
								((user.isLEA() &&
									(user.IsStaffAdmin ||
										!TransferCoordinatorPaymentToJurisdiction)) ||
									user.isCoordinator())
							}
							activeSection={activeSection}
							scrollToSection={this.scrollToSection}
						/>
					</div>
				</div>
			</div>
		);
	}
}

MyAccount.propTypes = {
	user: PropTypes.object,
	router: PropTypes.object.isRequired,
};

MyAccount.defaultProps = {
	user: {},
};

export default MyAccount;
